import { render, staticRenderFns } from "./Doctor.vue?vue&type=template&id=0727476a&scoped=true&"
import script from "./Doctor.vue?vue&type=script&lang=js&"
export * from "./Doctor.vue?vue&type=script&lang=js&"
import style0 from "./Doctor.vue?vue&type=style&index=0&id=0727476a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0727476a",
  null
  
)

export default component.exports